<template>
  <Card
    v-bind="$attrs"
    :morph="note.timeline_morph"
    :pinned="note.timeline_pinned"
    :simple="simple"
  >
    <q-item-section>
      <div class="text-caption text-bold">
        <span class="q-pr-xs">
          ({{ $formatSystemDate(note.timeline_date, fullDate || note.timeline_pinned ? luxonFormats.SHORT_WORDED_DATE_TIME : luxonFormats.TIME) }})
        </span>
        <span>
          {{ note.timeline_morph ? note.timeline_morph.type : null }} Note
        </span>
        <span v-if="note.is_updated" class="q-pl-xs">
          (Updated)
        </span>
      </div>
      <div
        ref="htmlContent"
        class="html"
        v-html="note.value"
      />
    </q-item-section>

    <template #menu>
      <q-item v-if="!!note.name" class="q-mb-md">
        <q-item-section>
          <q-item-label caption>
            Note Created By: <b>{{ note.name }}</b>
          </q-item-label>
        </q-item-section>
      </q-item>
      <q-item-wrapper
        v-close-popup
        clickable
        icon="mdi-content-copy"
        label="Copy Note to Clipboard"
        @click="copyToClipboard($refs.htmlContent ? $refs.htmlContent.innerHTML : '')"
      />
      <q-item-wrapper
        v-if="!readOnly"
        v-close-popup
        clickable
        icon="mdi-pencil"
        label="Edit..."
        @click="dialogOpen = true"
      />
      <q-item-wrapper
        v-if="!readOnly && !disablePinning"
        v-close-popup
        clickable
        :icon="note.timeline_pinned ? 'mdi-pin-off-outline' : 'mdi-pin-outline'"
        :label="note.timeline_pinned ? 'Unpin Note' : 'Pin Note'"
        @click="pinNote"
      />
      <q-separator
        v-if="!readOnly"
        inset
        class="q-my-sm"
      />
      <q-item-wrapper
        v-if="!readOnly"
        v-close-popup
        clickable
        color="red-8"
        class="text-bold"
        icon="mdi-close"
        label="Delete"
        @click="$emit('remove')"
      />
    </template>
  </Card>

  <!-- Edit Note -->
  <content-dialog
    v-model="dialogOpen"
    title="Edit Note..."
    width="750px"
    no-backdrop-dismiss
    fullscreen-mobile
    @before-show="onOpenEditDialog"
    @hide="clonedNote = null"
  >
    <text-editor
      v-if="!!clonedNote"
      v-model="clonedNote.value"
      class="q-pa-xs"
    />
    <template #bottom>
      <q-toolbar v-if="!!clonedNote">
        <q-space />
        <q-btn
          label="Save"
          color="green"
          icon-right="done"
          :disable="stripHtml(clonedNote.value || '').length < 1"
          @click="saveNote"
        />
      </q-toolbar>
    </template>
  </content-dialog>
</template>

<script>
import Card from 'components/partials/timeline/partials/Card'
import cardMixin from 'components/partials/timeline/partials/cardMixin'

export default {
  components: {
    Card
  },
  mixins: [cardMixin],
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  emits: ['remove', 'save', 'pin'],
  data () {
    return {
      dialogOpen: false,
      clonedNote: null
    }
  },
  methods: {
    onOpenEditDialog () {
      this.clonedNote = JSON.parse(JSON.stringify(this.note))
    },
    saveNote () {
      Object.assign(this.note, this.clonedNote)
      this.$emit('save', this.note)
      this.dialogOpen = false
    },
    pinNote () {
      this.note.timeline_pinned = !this.note.timeline_pinned
      this.$emit('pin')
    }
  }
}
</script>
